export const carsOrderEnum = Object.freeze({
    none: 0,
    registrationNoOrder: 1,
    meterReadingOrder: 2,
    ecoOrder: 3,
  });